import React, { PropTypes } from 'react';

const DMVPDButton = ({ text, link = 'http://www.espninstantaccess.com' }) => (
    <section className="watchProvider__btn">
        <a className="button-alt full-width lg" target="_blank" rel="noopener noreferrer" href={link}>
            <span>{text}</span>
        </a>
    </section>
);

DMVPDButton.propTypes = {
    text: PropTypes.string,
    link: PropTypes.string
};

export default DMVPDButton;



// WEBPACK FOOTER //
// ./app/common/chooseProvider/DMVPDButton.js